<template>
  <div class="allBox" id="allBox" @touchmove.prevent.stop>
    <div class="box">
      <div class="video_div" :class="[playClass ? 'has_play_img' : '']">
        <img
          style="height: 5.7rem;"
          v-show="status != 'living'"
          :src="detailObj.waitPic"
        />
        <video
          v-show="status == 'living'"
          ref="video"
          id="ele_video"
          :poster="detailObj.coverPic"
          controls="controls"
          :src="detailObj.livingUrl"
          playsinline="true"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          x5-playsinline=""
        ></video>
      </div>
      <div class="before_box" v-if="status == 'before'">
        {{ (detailObj.liveStartTime - 10 * 60 * 1000) | transMonth }}
        <span>精彩{{ res }}后呈现</span>
        <!-- <p class="p1">直播时间</p>
        <p class="p2">{{detailObj.liveStartTime - 10 * 60 * 1000 | transMonth}}</p>
        <x-button class="sign" @click.native="signUp">{{sign ? '已报名' : '立即报名'}}</x-button> -->
      </div>

      <div
        class="after_box"
        v-else-if="status == 'after'"
        @click="jump(end.id)"
      >
        <p class="p1">直播已结束</p>

        <p class="p2" v-if="end">为您推荐</p>
        <div class="after_div" v-if="end">
          <img :src="end.coverPicUrl" alt="" />
          <div>
            <p>{{ end.courseName }}</p>
            <p>
              <span class="end_name">{{ end.userName }}</span>
              <span class="end_company">{{ end.hospitalName }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="signup_cover" style="z-index: 9999;" v-show="cardFlag">
        <div class="sc_div">
          <h1>报名成功</h1>
          <p class="sc_p sc_pb">
            课程开始前10分钟，将会收到开课提醒，记得来上课哦
          </p>
          <p class="sc_pb">
            恭喜您获得一张邀请卡，请在医学V视界公众号查收！每邀请10位好友报名可获得1元红包！
          </p>
          <div class="ikbt" @click="hideCard">我知道啦</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: vux
import { XButton } from 'vux';
import { live, courseReport } from '@/api/ajax.js';
import { mapState } from 'vuex';
import { contentview } from '@/Mixin/contentview.js';
export default {
  name: '',
  mixins: [contentview],
  props: {
    categoriesArr: {
      type: Array,
      default() {
        return [];
      }
    },
    detailObj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isSignUp: {
      default: false
    },
    scType: ''
  },
  data() {
    return {
      controls: false,
      playClass: false,
      status: '',
      end: {},
      sign: false,
      cardFlag: false,
      liveStatusInter: null,
      res: ''
    };
  },
  methods: {
    hideCard() {
      this.cardFlag = false;
    },
    jump(id) {
      this.$router.push({
        name: 'courseDetail',
        params: {
          id: id
        }
      });
    },
    signUp() {
      if (!this.sign) {
        let wxUserInfoObj = this.$api.getStorage('wxUserInfo');
        this.cardFlag = true;
        let sendData = {
          id: this.$route.params.id
        };
        if (this.$route.query.visiterId) {
          sendData.visiterId = this.$route.query.visiterId;
          let wxUserInfoObj = this.$api.getStorage('wxUserInfo');
          //邀请卡带来的报名人数
          sa.track('activity', {
            type: 'subject representative',
            action: ' invitation_card_enrol',
            pageUrl: location.href,
            course_id: this.$route.params.id,
            course_name: this.detailObj.courseName,
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            client_phone: wxUserInfoObj.phone || '',
            from: 'wx',
            web_edition: 2
          });
        }
        live.wxCourseBook(sendData).then(res => {
          if (res.data.status == 'error') {
            this.$vux.toast.show({
              text: '报名失败',
              width: '5rem',
              type: 'cancel'
            });
          } else {
            // this.$vux.toast.show({
            //   text: '报名成功',
            //   width: '5rem',
            //   type: 'text'
            // })
            this.sign = true;

            //点击报名的神策
            sa.track('activity', {
              type: 'subject representative',
              action: ' enrol_user',
              pageUrl: location.href,
              course_id: this.$route.params.id,
              course_name: this.detailObj.courseName,
              client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
              client_phone: wxUserInfoObj.phone || '',
              from: 'wx',
              web_edition: 2
            });
            //神策发送名片的数量
            sa.track('activity', {
              type: 'subject representative',
              action: ' invitation_card',
              pageUrl: location.href,
              course_id: this.$route.params.id,
              course_name: this.detailObj.courseName,
              client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
              client_phone: wxUserInfoObj.phone || '',
              from: 'wx',
              web_edition: 2
            });
          }
        });
      }
    },
    liveEndRecommendVideoCourse() {
      live
        .liveEndRecommendVideoCourse({
          courseId: this.$route.params.id
        })
        .then(res => {
          let resp = res.data.data;
          if (resp) {
            this.end = resp[0];
          } else {
            this.end = null;
          }
        });
    },

    /*
     * 判断直播状态 直播前 中 后 // 需要与父级整合  更新当前状态
     * */
    liveStatus() {
      if (
        new Date().getTime() + 60 * 1000 * 10 <
        this.detailObj.liveStartTime
      ) {
        this.status = 'before';
      } else if (
        new Date().getTime() + 60 * 1000 * 10 > this.detailObj.liveStartTime &&
        new Date().getTime() < this.detailObj.liveEndTime
      ) {
        this.status = 'living';
      } else {
        this.status = 'after';
      }
    },
    /*
     * vide 初始化  主要对于微信中android ios 的不同处理
     * */
    videInfo() {
      //        if (this.$api.kernel() == 'wx' && this.$api.ios() == 'ios') {
      //          this.controls = true
      //
      //        } else {
      //          this.playClass = true
      //        }
    }
  },
  components: {
    XButton
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  watch: {
    detailObj(val) {
      this.liveEndRecommendVideoCourse(); //  获取直播结束后的推荐课程
      let restTime =
        (val.liveStartTime - new Date().getTime()) / 1000 / 60 / 60;
      if (val.liveStartTime - new Date().getTime() > 1000 * 60 * 10) {
        //开课前十分钟
        let restHour = Math.floor(restTime);
        let restMin = Math.floor((restTime - restHour) * 60);
        // console.log(restMin)
        if (restHour == 0) {
          this.res = restMin + '分钟';
        } else if (restMin == 0) {
          this.res = restHour + '小时';
        } else {
          this.res = restHour + '小时' + restMin + '分钟';
        }
      }
      if (this.$route.query.visiterId) {
        // 从邀请来的人
        let wxUserInfoObj = this.$api.getStorage('wxUserInfo');
        //邀请卡带来的报名人数
        sa.track('activity', {
          type: 'subject representative',
          action: ' invite_user',
          pageUrl: location.href,
          course_id: this.$route.params.id,
          course_name: this.detailObj.courseName,
          client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
          client_phone: wxUserInfoObj.phone || '',
          from: 'wx',
          web_edition: 2
        });
      }

      this.$nextTick(() => {
        this.pageStayTime('直播', this.liveStatus);
        this.videoPlay('直播');

        try {
          //防止断流不播放
          let eventTester = function(e) {
            $vm.$refs.video.addEventListener(
              e,
              function() {
                if (e == 'abort') {
                  $vm.$refs.video.play();
                }
              },
              false
            );
          };
          eventTester('abort');
        } catch (e) {
          console.error('没有直播地址');
        }
      });
    },
    isSignUp(val) {
      this.sign = val;
    }
  }
};
</script>

<style scoped lang="less">
@import '../../../../public/style/g.less';
.allBox {
  // height: 5.63rem;
}
.box {
  // position: fixed !important;
  // top: 1rem;
  // left:0;
  // z-index: 100;
  width: 100%;
  background: #fff;
}
.signup_cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
}

.sc_div {
  width: 8rem;
  height: 8.88rem;
  background: url(//cdn.yxvzb.com/img/course/Rectan1.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -4rem;
  padding-top: 0.8rem;
  text-align: center;
  h1 {
    font-size: 0.426667rem;
    width: 3rem;
    margin: auto;
    font-weight: normal;
    color: #161616;
  }
  p {
    font-size: 0.4rem;
    width: 5.7rem;
    margin: auto;
    text-align: left;
  }
  .sc_p {
    margin: 0.7333rem auto;
  }
  .ikbt {
    width: 5.1333rem;
    height: 1.1733rem;
    border-radius: 0.08rem;
    background: #027cfa;
    margin: auto;
    color: #fff;
    text-align: center;
    font-size: 0.4rem;
    line-height: 1.1733rem;
    margin-top: 0.8rem;
  }

  .sc_pb {
    position: relative;
  }

  .sc_pb:before {
    content: '';
    position: absolute;
    top: 0.3rem;
    left: -0.3rem;
    width: 0.15rem;
    height: 0.15rem;
    border-radius: 50%;
    background: #027af6;
  }
}

.sc_div:before {
  content: '';
  width: 3.6rem;
  height: 2.6666rem;
  background: url(//cdn.yxvzb.com/img/course/Grou2.png) no-repeat;
  background-size: 100%;
  position: absolute;
  right: -1.3rem;
  top: -1.1rem;
}

.box {
  position: relative;
  .video_div {
    width: 100%;
    // height: 4.5rem;
    position: relative;
    * {
      width: 100%;
      // height: 5rem;
    }
    #ele_video {
      width: 100%;
      height: 5.6267rem; /* 422/75 */
      //height:4.5rem;
    }
  }
  .has_play_img:before {
    content: '';
    background: url('//cdn.yxvzb.com/img/playimg.png') no-repeat;
    background-size: 100%;
    width: 2rem;
    height: 2rem;
    position: absolute;
    top: 1.5rem;
    left: 50%;
    z-index: 2;
    margin-left: -1rem;
  }
  .before_box {
    width: 100%;
    padding: 0 0.4rem;
    background-image: linear-gradient(-90deg, #027cfa 0%, #68dcff 100%);
    height: 0.93rem;
    font-size: 0.4rem;
    line-height: 0.93rem;
    color: #fff;
    // border-radius: .1rem;
    // position: absolute;
    // top: 5.7rem;
    // left: 0;
    // text-align: center;
    // z-index: 10;
    .sign {
      background-image: linear-gradient(-90deg, #027cfa 0%, #2cb9ff 100%);
      border-radius: 0.08rem;
      width: 3.2rem;
      height: 0.8rem;
      color: #fff;
      font-size: 0.3733rem;
      margin-top: 0.5rem;
    }
    .p2 {
      font-size: 0.4266rem;
      color: #027cfa;
      margin-top: 0.2rem;
    }
  }
  .p1 {
    font-size: 0.3733rem;
    color: #161616;
  }
  .after_box {
    width: 84%;
    padding: 0.5333rem 0.4rem;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 0.1rem;
    position: absolute;
    top: 13%;
    left: 8%;
    text-align: center;
    z-index: 10;
    .p2 {
      font-size: 0.32rem;
      color: #2d94ff;
      text-align: left;
    }
    .after_div {
      text-align: left;
      margin-top: 0.18rem;
      display: flex;
      justify-content: space-between;
      img {
        width: 2.66rem;
        height: 1.4933rem;
        border-radius: 2px;
      }
      div {
        width: 4.66rem;
        p:nth-of-type(1) {
          font-size: 0.32rem;
          color: #191919;
          .lineClamp(2);
        }
        p:nth-of-type(2) {
          display: flex;
          margin-top: 0.16rem;
          span {
            font-size: 0.267rem;
            color: #999;
          }
        }
        .end_name {
          margin-right: 0.133rem;
        }
        .end_company {
          width: 3.5rem;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
